import React from 'react';

/* eslint-disable react/prop-types */
export default function ({ color }) {
  // viewBox="0 0 16 17"
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.52 15.9957H1.44C1.184 15.9957 0.96 15.7717 0.96 15.5157V1.43569C0.96 1.17969 0.736 0.955688 0.48 0.955688C0.224 0.955688 0 1.17969 0 1.43569V15.5157C0 16.3157 0.64 16.9557 1.44 16.9557H15.52C15.776 16.9557 16 16.7317 16 16.4757C16 16.2197 15.776 15.9957 15.52 15.9957Z"
        fill={color}
      />
      <path
        d="M10.496 7.32367H9.37603C9.1993 7.32367 9.05603 7.46694 9.05603 7.64367V13.3397C9.05603 13.5164 9.1993 13.6597 9.37603 13.6597H10.496C10.6728 13.6597 10.816 13.5164 10.816 13.3397V7.64367C10.816 7.46694 10.6728 7.32367 10.496 7.32367Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.576 13.7236H13.696C13.888 13.7236 14.016 13.5956 14.016 13.4036V5.24365C14.016 5.05165 13.888 4.92365 13.696 4.92365H12.576C12.384 4.92365 12.256 5.05165 12.256 5.24365V13.3716C12.256 13.5636 12.416 13.6916 12.576 13.7236Z"
        fill={color}
      />
      <path
        d="M7.29595 9.17969H6.17596C5.99923 9.17969 5.85596 9.32296 5.85596 9.49969V13.3397C5.85596 13.5164 5.99923 13.6597 6.17596 13.6597H7.29595C7.47268 13.6597 7.61595 13.5164 7.61595 13.3397V9.49969C7.61595 9.32296 7.47268 9.17969 7.29595 9.17969Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.00799 13.6597H4.12798C4.31998 13.6597 4.44798 13.5317 4.44798 13.3397V11.3237C4.44798 11.1317 4.31998 11.0037 4.12798 11.0037H3.00799C2.81599 11.0037 2.68799 11.1317 2.68799 11.3237V13.3397C2.68799 13.5317 2.81599 13.6597 3.00799 13.6597Z"
        fill={color}
      />
    </>
  );
}
